import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userPlaceholder from "../assets/images/placeholder.jpg";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../components/shared/Loader";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { updateMeta } from "../store/actions/metaAction";

const AboutShow = () => {
	const auth = useSelector(state => state.auth.user);
	const [sectionOne, setSectionOne] = useState("");
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [loading, setLoading] = useState(true);
	const [sectionOnePicturePath, setSectionOnePicturePath] =
		useState(userPlaceholder);
	const [sectionTwoPicturePath, setSectionTwoPicturePath] =
		useState(userPlaceholder);
	const [pageTitle, setPageTitle] = useState("");
	const [pageUrl, setPageUrl] = useState("");
	const [pageDescrition, setPageDescrition] = useState("");
	const [pageKeyWords, setPageKeyWords] = useState("");
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "من نحن",
				breadcrumb: "من نحن",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/about_us/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setSectionOne(
					response.data.data[0].categories[0].posts[0].data.section1
				);
				setTitle(
					response.data.data[0].categories[0].posts[0].data.section2.title
				);
				setDescription(
					response.data.data[0].categories[0].posts[0].data.section2.description
				);
				setSectionOnePicturePath(
					response.data.data[0].categories[0].posts[0].data.picture1
				);
				setSectionTwoPicturePath(
					response.data.data[0].categories[0].posts[0].data.picture2
				);
				setPageTitle(
					response.data.data[0].categories[0].posts[0].data.pageTitle
				);
				setPageUrl(response.data.data[0].categories[0].posts[0].data.pageUrl);
				setPageDescrition(
					response.data.data[0].categories[0].posts[0].data.pageDecription
				);
				setPageKeyWords(
					response.data.data[0].categories[0].posts[0].data.pageKeyWords
				);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handleSectionOnePicture = () => {
		setLoading(true);
		const pictureOne = document.querySelector("#pictureOne");
		const data = new FormData();
		data.append("file", pictureOne.files[0]);
		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				setSectionOnePicturePath(response.data.data.name);
				setLoading(false);
				toast.success("تم رفع الصورة بنجاح!");
			})
			.catch(error => {
				toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};

	const handleSectionTwoPicture = () => {
		setLoading(true);
		const pictureTwo = document.querySelector("#pictureTwo");
		const data = new FormData();
		data.append("file", pictureTwo.files[0]);
		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				setSectionTwoPicturePath(response.data.data.name);
				setLoading(false);
				toast.success("تم رفع الصورة بنجاح!");
			})
			.catch(error => {
				toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};

	const handleSubmit = async e => {
		e.preventDefault();
		setLoading(true);
		const data = {
			section1: sectionOne,
			picture1: sectionOnePicturePath,
			picture2: sectionTwoPicturePath,
			section2: {
				title: title,
				description: description,
			},
			pageTitle: pageTitle,
			pageDecription: pageDescrition,
			pageKeyWords: pageKeyWords,
			pageUrl: pageUrl,
		};
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/65`,
				{
					admin_id: auth.data.id,
					category_id: 2,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث صفحة من نحن بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	let editor = null;

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							<div className="card-header">القسم الأول</div>
							<div className="card-body">
								<div className="form-item">
									<CKEditor
										data={sectionOne}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											// eslint-disable-next-line no-self-assign
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setSectionOne(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pictureOne">صورة القسم الاول</label>
									<input
										type="file"
										onChange={handleSectionOnePicture}
										id="pictureOne"
									/>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">القسم الثاني</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="name">العنوان</label>
									<input
										type="text"
										id="name"
										required
										value={title}
										onChange={e => setTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="name">الوصف</label>
									<CKEditor
										data={description}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											// eslint-disable-next-line no-self-assign
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pictureTwo">صورة القسم الثاني</label>
									<input
										type="file"
										onChange={handleSectionTwoPicture}
										id="pictureTwo"
									/>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="pageTitle">عنوان الصفحة</label>
									<input
										type="text"
										id="pageTitle"
										required
										onChange={e => setPageTitle(e.target.value)}
										value={pageTitle}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageUrl">رابط الصفحة</label>
									<input
										type="text"
										id="pageUrl"
										required
										onChange={e => setPageUrl(e.target.value)}
										value={pageUrl}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageDescription">وصف الصفحة</label>
									<textarea
										id="pageDescription"
										rows="2"
										onChange={e => setPageDescrition(e.target.value)}
										required
										value={pageDescrition}
									></textarea>
								</div>
								<div className="form-item">
									<label htmlFor="pageKeyWords">الكلمات المفتاحية</label>
									<textarea
										id="pageKeyWords"
										rows="2"
										onChange={e => setPageKeyWords(e.target.value)}
										required
										value={pageKeyWords}
									></textarea>
								</div>
								<div className="form-item mt-3">
									<button className="bt bt-success">ارسال</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default AboutShow;
